// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_6Gy","cls2":"AccountMenu-cls2_FiS AccountMenu-cls1_6Gy"};